export default function SmartStyles(setting = null, word) {
  let response = null;

  if (!word || setting === null) return response;

  if (setting === "padding") {
    if (word === "none") {
      response = "py-0";
    } else if (word === "both") {
      response = "py-12 md:py-24";
    } else if (word === "top") {
      response = "pt-12 md:pt-24";
    } else if (word === "bottom") {
      response = "pb-12 md:pb-24";
    }
  } else if (setting === "rounded") {
    if (word === "none") {
      response = "rounded-none";
    } else if (word === "both") {
      response = "rounded-3xl";
    } else if (word === "top") {
      response = "rounded-t-3xl";
    } else if (word === "bottom") {
      response = "rounded-b-3xl";
    }
  }

  return " " + response;
}
